import { Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { AuthServiceService } from '../../core/services/authService/auth-service.service';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { AuthRedirectService } from '@edtech-ui/core/services/auth-redirect/auth-redirect.service';
import { FireBaseServiceService } from '@edtech-ui/core/services/firebaseService/fire-base-service.service';
@Component({
	selector: 'app-user-registration-set-new-password',
	standalone: true,
	imports: [SharedModule],
	templateUrl: './user-registration-set-new-password.component.html',
	styleUrl: './user-registration-set-new-password.component.scss',
})
export class UserRegistrationSetNewPasswordComponent implements OnInit ,OnDestroy {
	showPassword: boolean = false;
	showConfirmPassword: boolean = false;
	form: FormGroup;
	subscription = new Subscription();
	isPasswordFocused = false;
	isConfirmPasswordFocused = false;
	isLoading: boolean = false;

	constructor(
		private router: Router,
		private _authService: AuthServiceService,
		private _toastr: ToastrService,
		private _authRedirectService: AuthRedirectService,
		private _fireBaseService: FireBaseServiceService,
	) {
		this.form = new FormGroup(
			{
				password: new FormControl('', [
					Validators.required,
					Validators.minLength(8),
				]),
				confirmPassword: new FormControl('', Validators.required),
			},
			{ validators: this.passwordMatchValidator }
		);
	}

	ngOnInit(): void {
		this._authRedirectService.redirectIfLoggedIn();
	}

	onSubmit() {
		if (this.form.valid) {
			this.isLoading = true;
			const email = this._authService.currentUserEmail.getValue();

			const payload = {
				new_password: this.form.value.password,
				email: email,
				reset_token: this._authService.resetToken.getValue(),
				fcm_token: this._authService.getFcmToken() || '',
			};

			this.subscription.add(
				this._authService.postSetNewPassword(payload).subscribe({
					next: (response) => {
						this.isLoading = false;
						if (response.Success) {
							this._toastr.success(response.Message);
							this.router.navigate(['messge']);
						} else {
							this._toastr.success(response.Message);
						}
					},
				})
			);
		}
	}

	togglePassword(field: 'password' | 'confirmPassword') {
		if (field === 'password') {
			this.showPassword = !this.showPassword;
		} else {
			this.showConfirmPassword = !this.showConfirmPassword;
		}
	}

	passwordMatchValidator: ValidatorFn = (
		control: AbstractControl
	): ValidationErrors | null => {
		const password = control.get('password')?.value;
		const confirmPassword = control.get('confirmPassword')?.value;
		return password === confirmPassword ? null : { passwordMismatch: true };
	};

	onPasswordFocus(): void {
		this.isPasswordFocused = true;
	}

	onPasswordBlur(): void {
		this.isPasswordFocused = !!this.form.controls['password'].value;
	}

	getPasswordPlaceholder(): string {
		return this.isPasswordFocused ? '' : 'set new password';
	}

	shouldFloatPasswordLabel(): boolean {
		return this.isPasswordFocused || !!this.form.controls['password'].value;
	}

	onConfirmPasswordFocus(): void {
		this.isConfirmPasswordFocused = true;
	}

	onConfirmPasswordBlur(): void {
		this.isConfirmPasswordFocused = !!this.form.controls['confirmPassword'].value;
	}

	getConfirmPasswordPlaceholder(): string {
		return this.isConfirmPasswordFocused ? '' : 'confirm new password';
	}

	shouldFloatConfirmPasswordLabel(): boolean {
		return this.isConfirmPasswordFocused || !!this.form.controls['confirmPassword'].value;
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
}
